import React, { useCallback, useRef, useState } from 'react';
import SoundHuntRoundView from './SoundHuntRoundView';
import LetterHuntRoundView from './LetterHuntRoundView';
import SoundDiscoveryRoundView from './SoundDiscoveryRoundView';

export default function TurkishL1RoundView({ round, ...props }) {
  const [step, setStep] = useState(round);
  const sharedAudioRef = useRef(null);
  const next = useCallback((value) => setStep({ ...value, continuing: true }), []);
  if (step.task_type === 'sound_discovery') {
    return <SoundDiscoveryRoundView key={step.round_id} {...props} round={step} sharedAudioRef={sharedAudioRef} onNextRound={next} />;
  }
  if (step.task_type === 'letter_hunt') {
    return <LetterHuntRoundView key={step.round_id} {...props} round={step} sharedAudioRef={sharedAudioRef} onNextRound={next} />;
  }
  return <SoundHuntRoundView key={step.round_id} {...props} round={step} sharedAudioRef={sharedAudioRef} onNextRound={next} />;
}
